/* eslint-disable react/no-danger */
import type { FC } from 'react';
import { useMemo, useState } from 'react';
import { Box, Button } from '@/DesignSystem/Component';
import { htmlStringNormalizer } from '@/Module/Core/Helper';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';
const LessonDetailDescription: FC = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const [showAll, setShowAll] = useState(false);
  const clickHandler = () => {
    setShowAll(!showAll);
  };
  const preparedDescription = useMemo(() => {
    if (lessonSection?.fullDescription) return htmlStringNormalizer(lessonSection.fullDescription);
    return htmlStringNormalizer(lessonSection?.description ?? '');
  }, [lessonSection?.description, lessonSection?.fullDescription]);
  if (!lessonSection) return null;
  return <Box color="white" className="mb-10 border-[6px] border-blackTwo px-4 py-6 lg:px-12 lg:py-10" data-sentry-element="Box" data-sentry-component="LessonDetailDescription" data-sentry-source-file="LessonDetailDescription.tsx">
      {preparedDescription && <div className={`customDescription prose mb-3 max-w-full text-justify leading-middle  lg:prose-xl prose-headings:my-0 prose-p:my-0 lg:mb-6 ${showAll ? 'line-clamp-none' : 'line-clamp-4 lg:line-clamp-6'}`} style={{
      whiteSpace: 'break-spaces'
    }} dangerouslySetInnerHTML={{
      __html: htmlStringNormalizer(preparedDescription)
    }} />}
      {preparedDescription && <div className="mt-8 justify-self-center">
          <Button variant="shadow" color="orange" radius="circle" size="large" onClick={clickHandler} bold>
            {showAll ? 'نمایش کمتر' : 'نمایش بیشتر'}
          </Button>
        </div>}
    </Box>;
};
export default LessonDetailDescription;